import styled from 'styled-components';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../../../components/helpers/Translator';

export default function CopisaResidualImpactProbRiskElement(props) {
  const {
    state,
    type,
    size = 16,
  } = props;

  return (
    <Container
      title={`${
        type === 'imp'
          ? 'Impacto residual'
          : type === 'prob'
          ? 'Probabilidad residual'
          : 'Riesgo Residual'
      } ${
        state !== null && state !== undefined
          ? ReactDOMServer.renderToString(
              <Translator
                file="filter"
                name={`filter.probability.${Math.floor(state)}`}
              />
            )
          : ''
      }`}
    >
      <Title className="text-center">
        {type === 'imp' ? 'I: ' : type === 'prob' ? 'P: ' : 'R: '}
      </Title>
      <Value className="text-center">{state}</Value>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  font-size: 11px;
  padding: 9px 0;
`;
const Title = styled.div`
  font-weight: lighter;
`;
const Value = styled.div`
  font-weight: bold;
`;
